import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import TableScrollContainer from 'components/Tables/ScrollContainer';
import BasicModal from 'components/Modals/presets/BasicModal';
import { css } from '@emotion/core';
import Switch from 'components/Kizen/Switch';
import Loader from 'components/Kizen/Loader';
export const StyledLinkWrapper = styled.div`
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
`;

export const ComponentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(
    100vh - ${({ heightReduction }) => heightReduction || 264}px
  );
  position: relative;
`;

export const TableWrapper = styled.div`
  width: 100%;
  flex: 1;
  border: 1px solid var(--color-border-medium);
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  flex-direction: column;
  position: relative;
  height: 100%;
  > div {
    position: relative;
    height: 100%;
  }
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  flex: 0 0 45px;
  padding-top: 20px;
`;

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  height: 100%;
  & .gradient-vertical-container {
    max-width: 100%;
    width: 100%;
  }
`;

export const StyledModal = styled(BasicModal)`
  && .modal-body {
    overflow: visible;
    ${({ showSearch }) =>
      showSearch &&
      css`
        padding-top: 0;
      `}
  }
  && .modal-header {
    padding-bottom: 1px;
  }
`;
export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin-bottom: 10px;
  margin-top: 3px;
`;

export const SearchPillWrapper = styled.div`
  position: absolute;
  ${({ mobileView }) =>
    mobileView
      ? css`
          top: 14px;
          right: 27px;
        `
      : css`
          top: 14px;
          right: 8px;
        `}
`;

export const StyledSwitch = styled(Switch)`
  margin: 14px 0 0 0;
`;

export const StyledMetaData = styled.p`
  font-family: 'Courier New', Monospace;
  font-size: 12px;
  white-space: pre-wrap;
  line-height: 1.5;
`;

export const StyledLoader = styled(Loader)`
  margin: 0 auto;
`;
